import { getAuthToken } from "../context/auth-context";
import { CALL_API } from "../context/constValues";
/* =========================
   HELPERS
========================= */
function normalizeDate(date) {
  if (!date) return null;
  return String(date).split("T")[0];
}

/* =========================
   OBTENER CHEQUES
========================= */
export async function getCheques() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/cheques`, {
    headers: {
      Authorization: "Bearer " + token,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "No se pudo obtener la lista de cheques");
  }

  return data.cheques;
}

/* =========================
   INSERTAR CHEQUE
========================= */
export async function insertCheque(objeto) {
  const {
    nombre,
    fechaemision,
    monto,
    concepto,
    orden,
    numeroderecibo,
    saldoanterior,
    deposito,
    total,
    saldo,
    idordendepago,
    idliquidacion,
    obs,
  } = objeto;

  /* VALIDACIONES */
  if (!nombre || !fechaemision || monto === undefined || !concepto || !obs) {
    throw new Error("Datos obligatorios incompletos");
  }

  if (!Number.isInteger(Number(monto))) {
    throw new Error("El monto del cheque debe ser un número entero");
  }

  const token = getAuthToken();

  const payload = {
    nombre,
    fechaemision: normalizeDate(fechaemision),
    monto: Number(monto),
    concepto,
    obs,

    orden: orden || "",
    numeroderecibo: numeroderecibo || null, // 👈 NUEVO

    saldoanterior: Number(saldoanterior) || 0,
    deposito: deposito || "",
    total: Number(total) || 0,
    saldo: Number(saldo) || 0,

    idordendepago: idordendepago || null,
    idliquidacion: idliquidacion || null,
  };

  const response = await fetch(`${CALL_API}/cheques`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Error al crear el cheque");
  }

  return data.isCreated;
}

/* =========================
   ACTUALIZAR CHEQUE
========================= */
export async function updateCheque(idcheque, objeto) {
  if (!idcheque) throw new Error("ID obligatorio");

  const {
    nombre,
    fechaemision,
    monto,
    concepto,
    orden,
    numeroderecibo,
    saldoanterior,
    deposito,
    total,
    saldo,
    obs,
  } = objeto;

  if (!fechaemision || !nombre || monto === undefined || !concepto || !obs) {
    throw new Error("Datos obligatorios incompletos");
  }

  if (!Number.isInteger(Number(monto))) {
    throw new Error("El monto debe ser entero");
  }

  const token = getAuthToken();

  const payload = {
    fechaemision: normalizeDate(fechaemision),
    nombre,
    monto: Number(monto),
    concepto,
    obs,

    orden: orden || "",
    numeroderecibo: numeroderecibo || null, // 👈 NUEVO

    saldoanterior: Number(saldoanterior) || 0,
    deposito: deposito || "",
    total: Number(total) || 0,
    saldo: Number(saldo) || 0,
  };

  const response = await fetch(`${CALL_API}/cheques/${idcheque}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al actualizar");
  }

  return data.isSaved;
}

/* =========================
   ELIMINAR CHEQUE
   (solo estado CREADO)
========================= */
export async function deleteCheque(idcheque) {
  if (!idcheque) {
    throw new Error("El ID del cheque es obligatorio");
  }

  const token = getAuthToken();

  const response = await fetch(`${CALL_API}/cheques/${idcheque}`, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + token,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "No se pudo eliminar el cheque");
  }

  return data.isDeleted;
}

/* =========================
   CAMBIAR ESTADO DE CHEQUE
========================= */
export async function updateChequeEstado(idcheque, objeto) {
  if (!idcheque) throw new Error("ID obligatorio");

  const { estado, numeroderecibo, motivodeanulado } = objeto;

  const estadosValidos = ["CREADO", "IMPRESO", "ENTREGADO", "ANULADO"];
  if (!estadosValidos.includes(estado)) {
    throw new Error("Estado inválido");
  }

  if (estado === "ENTREGADO" && !numeroderecibo) {
    throw new Error("Número de recibo obligatorio");
  }

  if (estado === "ANULADO" && !motivodeanulado) {
    throw new Error("Motivo de anulación obligatorio");
  }

  const token = getAuthToken();

  const payload = {
    estado,
    numeroderecibo: estado === "ENTREGADO" ? numeroderecibo : null,
    motivodeanulado: estado === "ANULADO" ? motivodeanulado : null,
  };

  const response = await fetch(
    `${CALL_API}/cheques/${idcheque}/estado`,
    {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error de estado");
  }

  return data.isSaved;
}
/* =========================
   FACTURAS CHEQUE PENDIENTE
========================= */
export async function getFacturasChequePendientes() {
  const token = getAuthToken();

  const response = await fetch(
    `${CALL_API}/ordendepago/facturas/cheque-pendiente`,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(
      data.message || "No se pudieron obtener las facturas en cheque pendientes"
    );
  }

  return data.facturas;
}
/* =========================
   PAGOS PROVEEDOR CHEQUE PENDIENTE
========================= */
export async function getPagoProveedorChequePendiente() {
  const token = getAuthToken();

  const response = await fetch(
    `${CALL_API}/ordendepago/proveedores/cheque-pendiente`,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(
      data.message || "No se pudieron obtener los pagos a proveedor en cheque pendientes"
    );
  }

  return data.pagoProveedores;
}
export async function getChequeById(id) {
  const token = getAuthToken();
  const res = await fetch(`${CALL_API}/cheques/${id}`, {
    headers: {
        Authorization: "Bearer " + token,
      },
  });

  if (!res.ok) throw new Error("Cheque no encontrado");
  return (await res.json()).cheque;
}
/**
 * Obtener cheques por rango de fecha de creación
 * @param {string} desde - YYYY-MM-DD
 * @param {string} hasta - YYYY-MM-DD
 */
export async function getChequesByFechaCreacion(desde, hasta) {
  const token = getAuthToken();

  const res = await fetch(
    `${CALL_API}/chequesbydate/fecha/creacion?desde=${desde}&hasta=${hasta}`,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );

  if (!res.ok) {
    const error = await res.json().catch(() => null);
    throw new Error(
      error?.message || "No se pudieron obtener los cheques"
    );
  }

  return (await res.json()).cheques;
}